import { render, staticRenderFns } from "./DownloadDocButton.vue?vue&type=template&id=276f6bb4&scoped=true&"
import script from "./DownloadDocButton.vue?vue&type=script&lang=js&"
export * from "./DownloadDocButton.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDocButton.vue?vue&type=style&index=0&id=276f6bb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276f6bb4",
  null
  
)

export default component.exports